export const businessUnits = ['PTRA', 'PBCI', 'PQGI'];

export const states = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const USER_LOGIN = "/signin";

export const NEW_REQUEST = "/order";

export const REGISTER_EXTERNAL_USER_WITH_LINK = "/user/register/partner";

export const DROPDOWN_VALUES_PATH = "/forms/drop-down";

export const FREIGHT_CREATE_ORDER = "/freight/order";

export const FREIGHT_ORDER_HISTORY = FREIGHT_CREATE_ORDER + "/history";

export const FREIGHT_ORDER_BY_TRACKING_NUMBER = FREIGHT_CREATE_ORDER + "/retrieve";

export const ADDRESS_SEARCH = "/freight/address";

export const ADDRESS_SEARCH_GET = "/freight/address/get";

export const errorResponse = { status: 400, message: "Something went wrong please try again after sometime.", data: "" };

